import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { APPSTORE, PLAYSTORE } from '@app/core';
import { CommonService } from '@app/core/services/common.service';
import { ReplaySubject, Subscription, takeUntil } from 'rxjs';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  platform = this._common.getOS();
  notifications = true;
  playstore = PLAYSTORE;
  appstore = APPSTORE;
  popupHide: boolean = true; // Set to true initially
  header: boolean = true;
  protected destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  consentAccepted: boolean = false;  // For consent banner

  constructor(
    public _common: CommonService,
    private _activated: ActivatedRoute
  ) {
    this._activated.queryParamMap.pipe(takeUntil(this.destroyed$)).subscribe((data) => {
      this.header = data.get('header') === 'false' ? false : true;
    });
  }

  ngOnInit(): void {
    // Check if the pop-up should be hidden based on session storage
    this.popupHide = !sessionStorage.getItem('modal');

    // Check if consent has been accepted before
    this.consentAccepted = localStorage.getItem('consentAccepted') === 'true';
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
  hidePopup() {
    console.log('Close button clicked!');
    this.popupHide = false;
    console.log('popupHide after click:', this.popupHide); // Debug log to check the value
    sessionStorage.setItem('modal', 'true');
  }





  // Method to accept consent
  acceptConsent(): void {
    localStorage.setItem('consentAccepted', 'true');
    this.consentAccepted = true;

    // Activate Google Analytics or other necessary scripts
    if (window.gtag) {
      window.gtag('consent', 'update', {
        'analytics_storage': 'granted',
        'ad_storage': 'granted'
      });
    }
  }
}

// Declaration of the gtag function in the global scope
declare global {
  interface Window {
    gtag: (...args: any[]) => void;
  }
}
